
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-53474e4d!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./JsonArrayColumnComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./JsonArrayColumnComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-53474e4d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./JsonArrayColumnComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/JsonArrayColumnComponent.vue
// module id = 225
// module chunks = 2